export default __webpack_public_path__ + "static/media/JOLT-Stake-icon.03c9049f.svg";